import React from 'react'
import { PageSupportedBrowsers } from '../../src/common/modules/supported-browsers/PageSupportedBrowsers'

export default () => <PageSupportedBrowsers />
